module.exports = __webpack_public_path__ + "static/media/icon_user_black.f623a056.svg";